import { Navbar, Nav } from 'react-bootstrap';

import { LinkContainer } from 'react-router-bootstrap';

export default function MyNav() {
  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Navbar.Brand>Josh's Cool App</Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">
          <LinkContainer to="/home">
            <Nav.Link>Home</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/about">
            <Nav.Link>About</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/main">
            <Nav.Link>Cheese</Nav.Link>
          </LinkContainer>
          <LinkContainer to="/tabulate">
            <Nav.Link>Tabulate</Nav.Link>
          </LinkContainer>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}
